import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

const MoloniEntities = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const isApp = Number(localStorage.getItem("isApp"));

  const data = [
    { id: 1, name: "customers", icon: "bi-people" },
    { id: 2, name: "suppliers", icon: "bi-truck" },
    { id: 3, name: "salesmen", icon: "bi-person-badge" },
  ];

  return (
    <div>
      <section className="content-header content-header-custom">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6 d-flex align-items-center">
              <button
                type="button"
                className="next-button btn btn-secondary"
                onClick={() => navigate("/moloni")}
              >
                <i className="bi bi-arrow-left"></i> {t("back")}
              </button>
            </div>

            <div className="col-sm-6 text-end">
              <h1
                className="page-title"
                // style={{
                //   marginTop: !isApp ? "0" : "-28px",
                // }}
              >
                {t("entities")}
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid container-custom-height-new">
          <div className="card bg-transparent shadow-none ">
            <ul className="list-group list-group-custom">
              {data.map((item) => (
                <li key={item.id} className="list-group-item">
                  <Link
                    className="d-flex align-items-center"
                    to={`/${item.name}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <i className={`icon-moloni bi ${item.icon} me-2`}></i>
                    {t(item.name)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MoloniEntities;
